// action types
import { createRequestTypes } from "../../utils";

export const FETCH_BREVO_TEMPLATES = createRequestTypes("FETCH_BREVO_TEMPLATES");

export const fetchBrevoTemplatesRequest = () =>
    ({ type: FETCH_BREVO_TEMPLATES.REQUEST });

export const fetchBrevoTemplatesSuccess = (data) =>
    ({ type: FETCH_BREVO_TEMPLATES.SUCCESS, payload: { data } });

export const fetchBrevoTemplatesFailure = (error) =>
    ({ type: FETCH_BREVO_TEMPLATES.FAILURE, payload: error });
